import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: fit-content;
    min-width: 415px;
    flex-shrink: 0;
    height: 56px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.interfacePure0};
    box-shadow: 35px 45px 73px rgba(32, 32, 35, 0.07);
    padding: 0 8px 0 8px;

    @media (max-width: 768px) {
        width: 100%;
        min-width: 0;
        flex: 1 1 auto;
        padding: 0 4px;
        height: 48px;
    }

    .tab {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 100%;
        padding: 0 16px;
        color: ${({ theme }) => theme.colors.interfaceText400};
        cursor: pointer;
        border-bottom: 2px solid transparent;
        transition: all .2s;
        &.selected {
            color: ${({ theme }) => theme.colors.interfaceText500};
            font-weight: 700;
            border-bottom: 2px solid ${({ theme }) => theme.colors.interfaceGray300};
        }

        @media (max-width: 768px) {
            padding: 0 8px;
            gap: 4px;
            font-size: 13px;
        }
    }

    .notification {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 25px;
        width: fit-content;
        height: 25px;
        background: ${({ theme }) => theme.colors.interfacePure100};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 12px;
        font-weight: 500;
        padding: 0 6px;
        &.selected {
            background: var(--count-badge-bg);
            color: var(--count-badge-ink);
        }
        @media (max-width: 768px) {
            min-width: 22px;
            height: 22px;
            font-size: 11px;
            padding: 0 4px;
        }
    }
`;
